var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessDiagnosis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff933c",
    d: "M23.75,15.23c.17.16.1.5-.15.75h0c-.25.25-.59.32-.75.15l-2.7-2.53c-.17-.16-.1-.5.15-.75h0c.25-.25.59-.32.76-.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff933c",
    strokeWidth: "0.25px",
    fill: "#ff933c",
    d: "M18,6.1a4.42,4.42,0,1,0,4.42,4.42A4.42,4.42,0,0,0,18,6.1Zm0,7.72a3.31,3.31,0,1,1,3.3-3.3A3.3,3.3,0,0,1,18,13.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: "2px",
    stroke: "var(--app-icons-color)",
    d: "M18.17,16l0-.22a1.25,1.25,0,0,1-.05.32,1,1,0,0,1-.95.68h-15a1,1,0,0,1-1-1V4.82a1,1,0,0,1,1-1h15a1,1,0,0,1,1,1v.55"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    stroke: "#ff933c",
    strokeWidth: "0.25px",
    fill: "#ff933c",
    x: 2.63,
    y: 9.67,
    width: 3.65,
    height: 1.03,
    rx: 0.52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#ff933c",
    strokeWidth: "0.25px",
    fill: "#ff933c",
    x: 4.43,
    y: 10.92,
    width: 3.65,
    height: 1.03,
    rx: 0.52,
    transform: "translate(14.87 1.64) rotate(70)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#ff933c",
    strokeWidth: "0.25px",
    fill: "#ff933c",
    x: 3.84,
    y: 9.01,
    width: 7.41,
    height: 1.03,
    rx: 0.52,
    transform: "translate(18.7 4.7) rotate(105)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#ff933c",
    strokeWidth: "0.25px",
    fill: "#ff933c",
    x: 6.44,
    y: 7.89,
    width: 4.95,
    height: 1.03,
    rx: 0.52,
    transform: "translate(14.7 -2.39) rotate(74.84)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    stroke: "#ff933c",
    strokeWidth: "0.25px",
    fill: "#ff933c",
    x: 8.99,
    y: 9.78,
    width: 3.54,
    height: 1.03,
    rx: 0.52
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    stroke: "var(--app-icons-color)",
    fill: "var(--app-icons-color)",
    strokeWidth: "0.75px",
    x: 6.15,
    y: 19.11,
    width: 7.89,
    height: 1.49,
    rx: 0.59
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessDiagnosis);
export default __webpack_public_path__ + "static/media/businessDiagnosis.8785f00c.svg";
export { ForwardRef as ReactComponent };